import { GridCustomCellProps } from '@progress/kendo-react-grid';
import dayjs from 'dayjs';
import { Link } from "react-router-dom";
import { isTrailerDateValid } from '../TrailerGrid';

const PositionCell = (props: GridCustomCellProps) => {
  if (!props.field) return null;

  return (
    <td {...props.tdProps}>
      {isTrailerDateValid(props.dataItem.LastPositionDateTime) && <>
        <Link style={{ color: "#007bff" }} to={`/Assets/Trailer/${props.dataItem.TrailerID}/Positions`}>{props.dataItem.LastPositionCity}, {props.dataItem.LastPositionState}</Link>
        <div style={{ fontSize: '11px' }}>{dayjs.utc(props.dataItem.LastPositionDateTime).tz("America/New_York").format("MM/DD/YYYY HH:mm")}</div>
      </>}
    </td>
  );
}

export default PositionCell;
